import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import { contactParentRejection } from '../../modules/contactParentRequired'
import { getTsdContactListData } from './mockData'
import type { ITsdContact } from '~/types/contact/models'

interface GettsdContactsResponse {
  data: ITsdContact[]
}

async function getTsdContacts(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GettsdContactsResponse = {
    data: await getTsdContactListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postTsdContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return (
    (await contactParentRejection(req, res, ctx, {
      parentKey: 'tsd',
      modelName: 'TsdContact',
    })) ?? addToEntityListData(req, res, ctx, getTsdContactListData)
  )
}

const patchTsdContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getTsdContactListData)
}

const deleteTsdContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getTsdContactListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/tsdcontacts',
    handler: getTsdContacts,
  },
  {
    method: 'post',
    path: '/api/tsdcontacts',
    handler: postTsdContact,
  },
  {
    method: 'patch',
    path: '/api/tsdcontacts/:id',
    handler: patchTsdContact,
  },
  {
    method: 'delete',
    path: '/api/tsdcontacts/:id',
    handler: deleteTsdContact,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
